import { api } from "../../lib/api";

export interface Security {
  id: string;
  ticker: string;
  isin: string | null;
  name: string;
  type: string;
  sector: string | null;
  market: string | null;
  currency: string;
  status: "listed" | "suspended" | "delisted";
  /** Bonds: prix unitaire d'acquisition. */
  faceValue: string | null;
  irvmRate: string | null;
  /** Bonds: annual nominal rate, in percent. */
  nominalRate: string | null;
  /** Bonds: lifetime in months. */
  durationMonths: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSecurityInput {
  ticker: string;
  name: string;
  type: string;
  isin?: string | null;
  sector?: string | null;
  market?: string;
  currency?: string;
  faceValue?: string | null;
  irvmRate?: string;
  nominalRate?: string | null;
  durationMonths?: number | null;
}

export const listSecurities = () =>
  api<{ data: Security[] }>("/admin/securities").then((r) => r.data);

export const createSecurity = (body: CreateSecurityInput) =>
  api<{ security: Security }>("/admin/securities", { method: "POST", body }).then((r) => r.security);

export const updateSecurity = (id: string, body: Partial<CreateSecurityInput> & { status?: string }) =>
  api<{ security: Security }>(`/admin/securities/${id}`, { method: "PATCH", body }).then(
    (r) => r.security,
  );
